<template>
    <div>
        <v-list three-line>
            <v-subheader>Conversations</v-subheader>
            <v-divider></v-divider>

            <div v-if="getCurrentChatList.length > 0">
                <template v-for="(item, index) in getCurrentChatList">    
                    <v-list-item
                        :key="index"
                        @click="openChat(item)"
                    >
                        <v-list-item-avatar>
                            <!-- Maybe just do an icon based on the chat type (we can change this into actual images later on) -->
                            <v-icon :color="hasReadChat(item.data) ? 'grey' : 'primary'">{{getChatIcon(item.data)}}</v-icon>
                        </v-list-item-avatar>
            
                        <v-list-item-content>
                            <v-list-item-title v-html="item.data.name"></v-list-item-title>
                            <v-list-item-subtitle v-html="getMessage(item.data)"></v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>
            </div>
            <div v-else>
                <v-list-item>
                    <v-list-item-title>No chats could be found</v-list-item-title>
                    <v-list-item-subtitle>Please try again later</v-list-item-subtitle>
                </v-list-item>
            </div>
        </v-list>

        <v-dialog v-model="chatDialog" :retain-focus="false" fullscreen class="overflow-x-hidden" hide-overlay transition="slide-x-transition">              
            <chat-dialog
            v-if="chatDialog"
            v-on:dialogClosed="closeChatDialog()"
            :chatId="currentChat.id"
            :userIds="currentChat.userIds"
            :userId="this.$route.params.userDb.uid">
            </chat-dialog>
        </v-dialog>

    </div>
</template>

<script>
// import moment from 'moment';
import ChatDialog from './../Chat/ChatDialog.vue'

export default {
    data () {
        return {
            localChatList: [],
            localUserId: "",
            chatDialog: false,
            currentChat: {}
        }
    },
    props: {
        chats: Array
    },
    components: {
        ChatDialog
    },
    mounted(){
        this.load();
    },
    methods: {
        load(){
            // This load method will have to initialise a listener for every id in the users chats (will we have to just do collection then filter down?)
            this.localUserId = this.$route.params.userDb.uid;
            this.localChatList = this.chats;
        },
        hasReadChat(chat){
            if(chat && !chat.read.includes(this.localUserId)){
                return false;
            } else {
                return true;
            }
        },
        getChatIcon(chat){
            if(chat && chat.type==="Group"){
                return 'mdi-account-group';
            } else {
                return 'mdi-account';
            }
        },
        getMessage(chat){
            //Get the most recent message -Use name instead over uid in the future?
            if (chat && chat.messages){
                if (this.hasReadChat(chat)){
                    return `<span class='text--primary'>${chat.messages[chat.messages.length-1].uid}</span> &mdash; ${chat.messages[chat.messages.length-1].content}`;
                } else {
                    return `<span class='text--primary'>${chat.messages[chat.messages.length-1].uid}</span> &mdash; <p class="font-weight-bold">${chat.messages[chat.messages.length-1].content}</p>`;
                }
            }
            return '';
        },
        openChat(chat){
            //Just do a normal get/search for the chat (if it exists with the expected user id's and chat type --> then just open that current chat with the chatID just obtained)
            this.currentChat = {id: chat.id, userIds: chat.data.users};
            this.chatDialog = true;
        },
        closeChatDialog(){
            this.chatDialog = false;
            this.currentChat = {};
        }
    },
    computed: {
        getCurrentChatList(){
            if(this.localChatList && this.localChatList.length > 0){
                return this.localChatList;
            } else {
                return [];
            }           
        }
    },
    watch: {
        chats: { 
            // the callback will be called immediately after the start of the observation
            immediate: true, 
            handler (val) {
                if (val !== null){
                    this.localChatList = val;
                }
            }
        }
    }
}
</script>